import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cancel-icon_jax_e1ac6002cda8d025f32785151bc3a80f",
  "use": "cancel-icon_jax_e1ac6002cda8d025f32785151bc3a80f-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"cancel-icon_jax_e1ac6002cda8d025f32785151bc3a80f\"><path d=\"M1 1l12 12M13 1L1 13\" stroke=\"#303030\" stroke-width=\"1.5\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol